"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdditionalCharge = void 0;
var isAdditionalCharge = function (itemSku) {
    return ["CALLOUTCHARGE", "HANDBALLCHARGE"].includes(itemSku);
};
exports.isAdditionalCharge = isAdditionalCharge;
